import modal from "@modul-connect/shared/components/atoms/modal"
import View from '@modul-connect/shared/components/atoms/view'
import Paper from '@modul-connect/shared/components/atoms/paper'
import LogChartMultipleCurves from "@modul-connect/shared/components/organisms/logChartMultipleCurves"
import { Fade, Modal } from "@mui/material"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useAuth0 } from "@auth0/auth0-react"
import { getVehicleHistoricalTemperatures } from "../../../state/actions/vehicles"
import { DateTime } from "luxon"
import Button from '@modul-connect/shared/components/atoms/button/button.v2'
import { useTranslation } from "react-i18next"

const colors = ['#27E6D0', '#7F00C9', '#FF4F66']

export const IncidentTemparatureChart = ({setOpenModal, openModal, mainboxId, startDate, endDate, title}) => {

  const dispatch = useDispatch()

  const {t} = useTranslation()

  const { getAccessTokenSilently } = useAuth0()
  useEffect(() => {
    if (openModal) {
      // Add/remove 10 minutes
      const formattedStartDate = startDate - 600 
      const formattedEndDate = endDate + 600
      getAccessTokenSilently()
        .then(token => {
          dispatch(getVehicleHistoricalTemperatures( token, mainboxId, formattedStartDate, formattedEndDate ))
        })
    }
  }, [openModal])

  const temperatureData = useSelector(state => state.vehicleHistoricalTemperatures[0]?.temperatures)
  const curves = useSelector(state => state.vehicleHistoricalTemperatures[0]?.historicalSensors)

  const loading = useSelector(state => state.loading.vehicleHistoricalSensors)

  return (
    <Modal
      open={openModal ? true : false}
      onClose={(event, reason) => {
        setOpenModal(false)
      }}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Fade in={openModal ? true : false}>
        <div>
          <Paper 
            title={title} 
            extend={{ 
              ...modal.container_v2, 
              left: '20%',
              width: '60%', 
              height: 'fit-content', 
              paddingBottom: 0, 
              overflow: 'hidden'
            }}
          >
            <View style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '440px'}}>
              <LogChartMultipleCurves
                data={temperatureData ?? []}
                curves={curves ?? []}
                unit="°C"
                displayTimeInHours={true}
                yAxisPadding={{ top: 10, bottom: 10 }}
                noYDecimals={false}
                intervalOptions={[]}
                selectedInterval={null}
                onIntervalChanged={() => {}}
                oldPicker={false}
                setStartTime={() => {}}
                setEndTime={() => {}}
                startTime={null}
                endTime={null}
                graphHeight={400}
                colors={colors}
                isLoading={loading === "loading"}
                fetchFailed={loading === "failed"}
              />
            </View>
            <View style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', gap: 10, marginBottom: '10px', width: '100%' }}>
              <Button noBg border onClick={() => {setOpenModal(false)}}>
                {t('climateSystem.tempHistory.close')}
              </Button>
            </View>
          </Paper>
        </div>
      </Fade>
    </Modal>
  )
}